import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconBarChartGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M18 20C17.45 20 16.9792 19.8042 16.5875 19.4125C16.1958 19.0208 16 18.55 16 18V15C16 14.45 16.1958 13.9792 16.5875 13.5875C16.9792 13.1958 17.45 13 18 13C18.55 13 19.0208 13.1958 19.4125 13.5875C19.8042 13.9792 20 14.45 20 15V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20ZM12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18V6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6V18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V11C4 10.45 4.19583 9.97917 4.5875 9.5875C4.97917 9.19583 5.45 9 6 9C6.55 9 7.02083 9.19583 7.4125 9.5875C7.80417 9.97917 8 10.45 8 11V18C8 18.55 7.80417 19.0208 7.4125 19.4125C7.02083 19.8042 6.55 20 6 20Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconBarChartSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconBarChartGroup {...props} />
    </svg>
  );
};
